

var wrapper = document.querySelector(".reverse--sticky");
var scrollPos = 0;
//var initTop = wrapper.getBoundingClientRect().top;
var wrapperHeight = wrapper.getBoundingClientRect().bottom - wrapper.getBoundingClientRect().top;
var lastScrolled = this.window.scrollY;
var currentScroll = 0;
var lastBot = 0;
var fixedBot = 0;

var accordions = document.querySelectorAll(".product__accordion");

//console.log(wrapperHeight);

accordions.forEach(function(accordion) {
    accordion.addEventListener("click", function() {
        setTimeout(function() {
            wrapperHeight = wrapper.getBoundingClientRect().bottom - wrapper.getBoundingClientRect().top;
            console.log(wrapperHeight);
        }, 300)
    })
})

window.addEventListener("scroll", function(){
    if(window.innerWidth > 749) {    
        if (lastBot == wrapper.getBoundingClientRect().bottom) {
            fixedBot = lastBot;
        }

        if((document.body.getBoundingClientRect()).top < scrollPos) {
            if(currentScroll + this.window.scrollY - lastScrolled <= wrapperHeight - window.innerHeight + 200) {
                currentScroll += this.window.scrollY - lastScrolled
                wrapper.style.top = ( -currentScroll) + "px";
            }
        } else if((document.body.getBoundingClientRect()).top > scrollPos && wrapper.getBoundingClientRect().top <= 233 ) {
            if(wrapper.getBoundingClientRect().bottom >= fixedBot) {
                currentScroll += this.window.scrollY - lastScrolled 
                wrapper.style.top = ( -currentScroll) + "px";
            } 
        }
        
        scrollPos = (document.body.getBoundingClientRect()).top;
        lastScrolled = this.window.scrollY
        lastBot = wrapper.getBoundingClientRect().bottom        
    };  
})